// extracted by mini-css-extract-plugin
export var onlineBenefits = "pos-module--onlineBenefits--LXeup";
export var whyOnlineBenefit = "pos-module--whyOnlineBenefit--3Fuqm";
export var whyOnlineDescription = "pos-module--whyOnlineDescription--XcnP0";
export var whyOnlineHead = "pos-module--whyOnlineHead--DCy5f";
export var whyOnlineImage = "pos-module--whyOnlineImage--KGXcb";
export var whyOnlineParent = "pos-module--whyOnlineParent--gkRZE";
export var whyOnlineTagline = "pos-module--whyOnlineTagline--yjONc";